import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ChevronLeftSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        xmlns='http://www.w3.org/2000/svg'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.8567 4.35178C13.082 4.5771 13.2085 4.88265 13.2085 5.20125C13.2085 5.51984 13.082 5.82539 12.8567 6.05071L8.90017 10.0073L12.8567 13.9638C13.0756 14.1904 13.1967 14.4939 13.1939 14.8089C13.1912 15.124 13.0648 15.4253 12.8421 15.6481C12.6193 15.8709 12.318 15.9972 12.0029 16C11.6879 16.0027 11.3844 15.8816 11.1578 15.6627L6.35178 10.8567C6.12654 10.6314 6 10.3258 6 10.0073C6 9.68866 6.12654 9.38311 6.35178 9.15779L11.1578 4.35178C11.3831 4.12654 11.6887 4 12.0073 4C12.3258 4 12.6314 4.12654 12.8567 4.35178Z'
      />
    </svg>
  );
};
